export default "__VITE_ASSET__BlpTqMci__"